import { BASE_URL } from '../constants/constants';
import axiosRequestInterceptor from '../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../utils/logger';

export const logUserActivity = async ({
	userId,
	eventType,
	startTime,
	endTime,
	durationSec,
	topicId,
	subtopicId,
	// notebookId,
}) => {
	try {
		const payload = {
			USER_ID: userId,
			EVENT_TIMESTAMP: startTime,
			EVENT_TYPE: eventType,
			START_TIME: startTime,
			END_TIME: endTime,
			DURATION_SEC: durationSec,
			TOPIC_ID: topicId,
			SUBTOPIC_ID: subtopicId,
		};
		const response = await axiosRequestInterceptor.post(`/users/user-activity-log`, {
			userActivityData: payload,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchTimePerQuestion = async (userId) => {
	console.log('User ID inside getTimePerQuestion===> ', userId);
	try {
		const response = await axiosRequestInterceptor.post(`/users/getTimePerQuestion`, {
			userId: userId,
		});
		console.log('response from getTimePerQuestion: ', response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchStudyTime = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post(`/users/get-study-hours`, {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const getHeapMapData = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/subtopic-mastery-with-color', {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchStudentTestAccuracy = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/student-test-accuracy', {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchMissedQuestionDetails = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/missed-kcs', {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchUserActivitySummary = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/user-activity-summary', {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchUserBadgeDetails = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/badge-details', {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchWeeklyLearningStreak = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/weekly-learning-streak', {
			userId: userId,
		});

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchUsersXPProgress = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/user-xp-progress', {
			userId: userId,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const updateXPMetrics = async (userId, type, increment) => {
	try {
		const response = await axiosRequestInterceptor.post('/users/update-xp', {
			userId: userId,
			type: type,
			increment: increment,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const uploadProfilePicture = async (formData) => {
	try {
		const response = await axiosRequestInterceptor.post(
			'/users/upload-profile-picture',
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error:', error);
		return { success: false, error: error.response.data.error };
	}
};
